import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import Alert from '@/components/Alert';
import Card from '@/components/Card';
import Table from '@/components/Table';
import { Body } from '@/components/Typography';
import { TableCell, TableRow } from '@/elements/Table';
import useAuth from '@/hooks/useAuth';
import { Role } from '@/routes/PrivateRoute';
import { StripeInvoice } from '@/types/graphql';
import { centsToCurrency } from '@/util/number';

type Props = {
  invoice: unknown;
};

const TotalsCard = ({ invoice }: Props) => {
  const { currentAdmin } = useAuth();
  const { subtotal, total, amountDue } = invoice as StripeInvoice;
  const invoiceSubtotal = centsToCurrency(Number(subtotal));
  const invoiceTotal = centsToCurrency(Number(total));
  const invoiceAmountDue = centsToCurrency(Number(amountDue));
  const rows = [
    { title: 'Subtotal', amount: invoiceSubtotal },
    { title: 'Total', amount: invoiceTotal },
    { title: 'Amount Due', amount: invoiceAmountDue },
  ];

  return (
    <Card size="sm">
      <Table>
        <tbody>
          {rows.map(({ title, amount }, index) => {
            const isLastElement = index === rows.length - 1;

            return (
              <TableRow key={`totals-card-${index}`}>
                <TableCell>
                  <Body weight={isLastElement ? 'bold' : 'normal'}>
                    {title}
                  </Body>
                </TableCell>
                <TableCell align="right">
                  <Body weight={isLastElement ? 'bold' : 'normal'}>
                    ${amount}
                  </Body>
                </TableCell>
              </TableRow>
            );
          })}
          {currentAdmin?.role !== Role.TENANT_ADMIN && (
            <TableRow>
              <TableCell colSpan={2}>
                <Alert
                  icon={faExclamationTriangle}
                  status="neutral"
                  title="Please note that late payments are subject to a 50% fee."
                />
              </TableCell>
            </TableRow>
          )}
        </tbody>
      </Table>
    </Card>
  );
};

export default TotalsCard;
